import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import $ from "jquery";
import Screen from "@bd-utils/screen";
import Paintings from "@bd-utils/object";

export const MirrorPage = () => {
    const isMirrorTemplate = $("#mirror-page").length > 0;

    if (!isMirrorTemplate) return;

    const elms = {
        popup: "#mirror-popup",
        allowCameraBtn: "#allow-camera-btn",
        facecamVideo: "#facecam-video",
        facecamPlaceholder: "#facecam-placeholder",
        paintingVideo: "#painting-video",
        paintingPlaceholder: "#painting-placeholder",
        continueBtn: "#continue-btn",
        headerInfo: "#header-info",
        subtitle: ".js-subtitle",
    };

    const initPopup = () => {
        showPopup();
    };

    const showPopup = () => {
        $(elms.popup).addClass("is-open");
    };

    const hidePopup = () => {
        $(elms.popup).removeClass("is-open");
    };

    const showHeaderInfo = () => {
        $(elms.headerInfo).addClass("is-visible");
    };

    const hideHeaderInfo = () => {
        $(elms.headerInfo).removeClass("is-visible");
    };

    const handleAllowCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    width: 200,
                    height: 200,
                    facingMode: "user",
                },
            });

            const videoElement = $(elms.facecamVideo)[0];
            if (videoElement && "srcObject" in videoElement) {
                videoElement.srcObject = stream;
            }
            $(elms.facecamVideo).addClass("is-active");
            $(elms.facecamPlaceholder).addClass("is-hidden");
        } catch (error) {
            console.error("Error accessing camera:", error);
            alert("Unable to access camera. Please check your permissions.");
        }

        startPaintingVideo();
        hidePopup();
        showHeaderInfo();
    };

    const startPaintingVideo = () => {
        const paintingVideoElement = $(elms.paintingVideo)[0];
        if (
            paintingVideoElement &&
            paintingVideoElement instanceof HTMLVideoElement
        ) {
            const source = paintingVideoElement.querySelector("source");
            if (source && source.src) {
                paintingVideoElement.addEventListener("timeupdate", () => {
                    const textTracks = paintingVideoElement.textTracks;

                    if (textTracks && textTracks.length > 0) {
                        const track = textTracks[0];
                        track.mode = "hidden";
                        // Check if track is loaded and has cues
                        if (track.cues && track.cues.length > 0) {
                            const cues = track.activeCues;
                            if (cues && cues.length > 0) {
                                $(elms.subtitle).addClass("is-open");
                                const activeCue = cues[0];
                                const cueText =
                                    /** @type {any} */ (activeCue).text ||
                                    activeCue.toString() ||
                                    "No text available";

                                $(elms.subtitle).text(cueText);
                            } else {
                                $(elms.subtitle).text("");
                                $(elms.subtitle).removeClass("is-open");
                            }
                        }
                    }
                });

                paintingVideoElement.addEventListener("ended", () => {
                    $(elms.paintingVideo)
                        .removeClass("is-active")
                });

                paintingVideoElement.load();
                paintingVideoElement
                    .play()
                    .then(() => {
                        paintingVideoElement.muted = false;
                        $(elms.paintingVideo).addClass("is-active");
                        $(elms.paintingPlaceholder).addClass("is-hidden");
                    })
                    .catch((error) => {
                        console.error("Error playing painting video:", error);
                    });
            } else {
                console.warn("No painting video source found");
            }
        }
    };

    const handleContinue = () => {
        $(elms.continueBtn).addClass("is-loading");

        bdjs.goAsync(
            bdapi.post("game/finish-game-mirror").then(() => {
                $(elms.continueBtn).removeClass("is-loading");
                $(elms.continueBtn).addClass("is-completed");
                window.location.href = CONFIG.siteURL + "/result/";
            }),
        );
    };

    // Event listeners
    $(elms.allowCameraBtn).on("click", handleAllowCamera);
    $(elms.continueBtn).on("click", handleContinue);
    $(window).on("resize", function () {
        Screen.calculateCoverSize();
        Paintings.calculateCoverSize();
    });
    $(window).on("load", function () {
        Screen.calculateCoverSize();
        Paintings.calculateCoverSize();
    });

    // Initialize
    initPopup();

    return {
        showPopup,
        hidePopup,
        showHeaderInfo,
        hideHeaderInfo,
        isOpen: () => $(elms.popup).hasClass("is-open"),
    };
};
